$(document).ready(function() {
    $('.custom-card-review-main').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000, // optional: autoplay ki speed (milliseconds)
        speed: 500,
        infinite: true,
        draggable: true,
        dots: false,
        pauseOnHover: false,  // hover par pause nhi hoga
        pauseOnFocus: false,  // focus par pause nhi hoga
        pauseOnDotsHover: false // dots hover par pause nhi hoga
    });
});